import { select } from "@redux-saga/core/effects";
import axios from "axios";
import { takeEvery, take, put, fork, call, race, delay } from "redux-saga/effects";
import AuthService from "../../services/auth";
import { cancelAllRequests } from "../../utils/netRequest";
import { submitFormRoutine } from "../../forms/Login/actions";
import { submitFormRoutine as submitFormVerify } from "../../forms/SmsVerification/actions";
import { submitFormRoutine as submitFormPaymentAuth } from "../actions/formRoutines/paymentAuthorization";
import { authorizationActionCreators, authorizationActions } from "../actions/authorization";
import * as firebaseActions from "../actions/firebase";
import { setToken, getToken, removeToken } from "../../utils/token";
import { waitForFcmToken } from "./firebase";

function* wsHandling(dispatch) {

  const checkResponse = (response) => {
    function logout() {
      cancelAllRequests();
      dispatch(authorizationActionCreators.logout(true));
      window.location.reload();
    }

    if (response) {
      if (response.status === 401) {
        logout();
      } else if (response.status === 400) {
        if ([ 1011, 1014, 1015, 1016 ].includes(response.data.errorCode)) {
          logout()
        }
      }
    }
  };

  yield call(
    axios.interceptors.response.use.bind(axios.interceptors.response),
    function (response) {
      checkResponse(response);
      return response;
    },
    function ({ response }) {
      checkResponse(response);
    },
  );
}

function* startAuthorizing() {
  yield put(authorizationActionCreators.changeFetchingStatus(true));
}

function* stopAuthorizing() {
  yield put(authorizationActionCreators.changeFetchingStatus(false));
}

function* logout({ payload: { skipRequest } }) {
  yield call(() => {
    if (!skipRequest && getToken()) {
      try {
        AuthService.logout();
      } finally {
        removeToken();
      }
    } else {
      removeToken();
    }
  });
}

function* savePhoneNumber({ payload: phone }) {
  yield put(authorizationActionCreators.setPhoneNumber(phone));
}

function* saveClientInfo({ payload: { token, client } }) {
  setToken(token);
  const data = yield put(authorizationActionCreators.setUserToken(token));
  yield put(authorizationActionCreators.setClient(client));
  yield put(authorizationActionCreators.setTerms(true));
  if (data) {
    yield call(AuthService.authAgreeTerms);
  }
}

function* handlePaymentAuthorizedModal() {
  yield put(authorizationActionCreators.handlePaymentAuthorizedModal());
}

function* tryLoadToken() {
  yield put(authorizationActionCreators.changeFetchingStatus(true));
  const token = getToken();
  if (token && token !== "undefined") {
    yield put(authorizationActionCreators.restoreSession(true));
    yield put(authorizationActionCreators.setUserToken(token));
    yield waitForFcmToken();
    const { authorization, firebase } = yield select();
    const payload = yield call(AuthService.auth, authorization["Phone.CountryCode.Id"], authorization.Phone, firebase.fcmToken);
    yield saveClientInfo({ payload });
  } else {
    removeToken();
  }
  yield put(authorizationActionCreators.restoreSession(false));
  yield put(authorizationActionCreators.changeFetchingStatus(false));
}

export default [
  tryLoadToken(),
  takeEvery(submitFormRoutine.SUCCESS, savePhoneNumber),
  takeEvery(submitFormVerify.REQUEST, startAuthorizing),
  takeEvery(submitFormVerify.FULFILL, stopAuthorizing),
  takeEvery(submitFormVerify.SUCCESS, saveClientInfo),
  takeEvery(submitFormPaymentAuth.SUCCESS, handlePaymentAuthorizedModal),
  takeEvery(authorizationActions.logout, logout),
  ({ dispatch }) => fork(wsHandling, dispatch),
];
